<template>
  <n-config-provider :theme-overrides="themeOverrides">
    <div id="app">
      <n-message-provider>
        <router-view v-slot="{ Component }">
          <keep-alive :max="10" :include="['HomeView']">
            <component :is="Component" />
          </keep-alive>
        </router-view>
      </n-message-provider>
    </div>
  </n-config-provider>
</template>

<script setup>
import { NConfigProvider } from "naive-ui";
const themeOverrides = {
  Input: {
    boxShadowFocus: "none",
    boxShadowFocusError: "none",
    boxShadowFocusWarning: "none",
  },
};
</script>

<style lang='scss' scoped>
#app {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  min-height: 500px;
  font-size: 16px;
  font-family: $font-family;
}
</style>
